import {
  withScope,
  captureException as sentryCaptureException,
  captureMessage as sentryCaptureMessage
} from '@sentry/browser'
import config from '#src/config'

/**
 * Sentry doesn't have a default export so we'd need to desonstruct the object each time and
 * have some annoying namespace reservation. This small service allows for a single import.
 *
 * See:
 * https://github.com/getsentry/sentry-javascript/blob/master/packages/browser/src/index.ts
 */
interface AdditionalData {
  // Sentry types this as 'any' themselves
  [key: string]: any
}

function isNetworkRelatedError(additionalData: AdditionalData) {
  return (
    additionalData.networkError &&
    additionalData.networkError.name &&
    additionalData.networkError.name === 'Error'
  )
}

export function captureException(message: string | Error, additionalData?: AdditionalData) {
  if (config.get('sentry.enabled')) {
    if (additionalData) {
      withScope(scope => {
        for (let n in additionalData) {
          scope.setExtra(n, additionalData[n])
        }
        sentryCaptureException(message)
      })
    } else {
      sentryCaptureException(message)
    }
  }

  console.error(message, additionalData)
}

export function captureMessage(message: string, additionalData?: AdditionalData) {
  if (config.get('sentry.enabled')) {
    if (additionalData) {
      withScope(scope => {
        for (let n in additionalData) {
          scope.setExtra(n, additionalData[n])
        }

        if (isNetworkRelatedError(additionalData)) {
          scope.setFingerprint(['{{ default }}', 'network error'])
        }

        sentryCaptureMessage(message)
      })
    } else {
      sentryCaptureMessage(message)
    }
  }

  console.log(message, additionalData)
}

export default {
  captureException,
  captureMessage
}
